import styled from 'styled-components';

export const TooltipWrapper = styled.div`
    width: 1rem;
    height: 1rem;
    transform: translate(0, 2rem);
`;

export const TooltipContentWrapper = styled.div`
    min-width: 32.8rem;
    max-width: 33.6rem;
    background: white;
    border-radius: 0.8rem;
    display: flex;
    justify-content: center;
    box-shadow: 0 0.2rem 1.6rem rgba(176, 188, 200, 0.6);
    align-items: center;
`;
